<script setup lang="ts">
import { mainNavigationQaEquipment, mainNavigationMedicalSystems } from '@/components/icons/icons';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import { truthy } from '@/utils/helper';
import SetupParameter from '@/views/tasks/components/SetupParameter.vue';
import { groupBy } from 'lodash';
import { computed } from 'vue';
import { ParameterCombinationTitleValues } from './useTaskStepTitles';

const props = defineProps<{
  combination: ParameterCombinationTitleValues;
}>();

const target = computed(() => props.combination?.target?.filter(truthy));

const support = computed(() => groupBy(props.combination?.support?.filter(truthy), 'groupName'));

const isEmpty = computed(
  () => !props.combination?.target?.length && !props.combination?.support?.length,
);
</script>

<template>
  <span v-if="isEmpty">
    {{ $t('Workstep') }}
  </span>

  <div v-else class="d-flex align-center">
    <v-icon
      v-if="target?.length"
      color="secondary"
      :icon="mainNavigationMedicalSystems"
      class="mr-2"
    />

    <template v-for="(item, index) in target" :key="index">
      <span v-if="index !== 0" class="ml-1 mr-1"> | </span>
      <SetupParameter :item="item" />
    </template>

    <template v-for="(parameters, groupName) in support" :key="groupName">
      <Tooltip v-if="parameters?.length" position="top" :showPointer="true">
        <template #target="{ props: tooltipProps }">
          <v-icon
            v-bind="tooltipProps"
            color="secondary"
            :icon="mainNavigationQaEquipment"
            class="mr-2 ml-6"
          />
        </template>
        <template #tooltip>
          {{ groupName }}
        </template>
      </Tooltip>

      <template v-for="(item, index) in parameters" :key="index">
        <span v-if="index !== 0"> | </span>
        <SetupParameter :item="item" />
      </template>
    </template>
  </div>
</template>
